import React from 'react';
import { getColor, getTextColor } from '../../common/ThemeService';
import './landingPageFilter.css';

class LandingPageFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedGameType: this.props.gameType,
            selectedDateRange: this.props.dateRange,
            gameTypeList: [{ label: 'NLH Cash Games', value: 'cash' },{ label: 'PLO Cash Games', value: 'PLO' }, { label: 'Tournament Games', value: 'tournament' },{ label: 'Spin Games', value: 'spin' }],
            dateRangeList: [{ value: 'Today', label: 'Today' }, { value: 'Yesterday', label: 'Yesterday' }, { value: 'Last 7 days', label: 'Last 7 days' },
            { label: 'This Week', value: 'This Week' },{ label: 'Last Week', value: 'Last Week' }, { label: 'This Month', value: 'This Month' },{ label: 'Last Month', value: 'Last Month' },
             { label: 'This Year', value: 'This Year' },{ label: 'Last Year', value: 'Last Year' }]
        }
    }

    onChange(e) {
        this.setState({ selectedGameType: e.target.value })
    }

    onChangeTime(e) {
        this.setState({ selectedDateRange: e.target.value })
    }

    render() {
        const themeColor = getColor();
        const themeTextColor = getTextColor();
        let { selectedGameType, gameTypeList,selectedDateRange,dateRangeList } = this.state
        console.log("dateRangeList",dateRangeList);
        return (
            <div className="landingPageFilterMain">
                <div className="landingPageFliter">
                    <div className="pageFilterHeading">Page Filters
                        <i className="fa fa-times closeLandingPageFilter" onClick={this.props.closeFilter}></i>
                    </div>
                    <div className="landingPageSelectBox">
                        Game
                    </div>
                    <label className="landinPageFilterLabel">
                        <select className="landingPageSelectFilter" value={selectedGameType} onChange={(e) => this.onChange(e)} >
                            {gameTypeList.map(game => <option value={game.value}>{game.label}</option>)}
                        </select>
                    </label>
                    <div className="landingPageSelectBox">
                        Time
                    </div>
                    <label className="landinPageFilterLabel">
                        <select className="landingPageSelectFilter" value={selectedDateRange} onChange={(e) => this.onChangeTime(e)} >
                            {dateRangeList.map(game => <option value={game.value}>{game.label}</option>)}
                        </select>
                    </label>
                    <center><button className="submitReportFilter" onClick={() => this.props.submitLandingPageFilter(selectedGameType,selectedDateRange)}
                    style={{
                        backgroundColor: themeColor,
                        borderColor: themeColor,
                        color: themeTextColor,
                    }}
                    >Apply</button></center>
                </div>
            </div>
        )
    }
}




export default LandingPageFilter;


/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/LandingPageFilter.js
 **/